
import React from 'react';
import { motion } from 'framer-motion';
import { MagicBento } from './ui/magic-bento';
import LightRays from './ui/LightRays';
import { Language } from '../types';
import { translations } from '../translations';

interface AboutProps {
  lang: Language;
}

const About: React.FC<AboutProps> = ({ lang }) => {
  const t = translations[lang].about;
  
  const featureData = [
    {
      title: t.features.profit.label,
      description: t.features.profit.desc,
      icon: (
        <svg className="w-10 h-10 text-sky-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="1.5" d="M13 7h8m0 0v8m0-8l-8 8-4-4-6 6" />
        </svg>
      )
    },
    {
      title: t.features.risk.label,
      description: t.features.risk.desc,
      icon: (
        <svg className="w-10 h-10 text-sky-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="1.5" d="M9 12l2 2 4-4m5.618-4.016A11.955 11.955 0 0112 2.944a11.955 11.955 0 01-8.618 3.04A12.02 12.02 0 003 9c0 5.591 3.824 10.29 9 11.622 5.176-1.332 9-6.03 9-11.622 0-1.042-.133-2.052-.382-3.016z" />
        </svg>
      )
    },
    {
      title: t.features.history.label,
      description: t.features.history.desc,
      icon: (
        <svg className="w-10 h-10 text-sky-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="1.5" d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z" />
        </svg>
      )
    }
  ];

  return (
    <section id="about" className="pt-32 pb-40 bg-black border-t border-white/5 relative overflow-hidden min-h-screen flex flex-col justify-center">
      <div className="absolute inset-0 z-0 opacity-40">
        <LightRays raysOrigin="top-center" raysColor="#0ea5e9" raysSpeed={0.8} lightSpread={0.6} rayLength={3} followMouse={true} mouseInfluence={0.08} noiseAmount={0.02} distortion={0.05} pulsating={false} fadeDistance={1.2} saturation={1} />
      </div>
      <div className="max-w-7xl mx-auto px-6 relative z-10 w-full">
        <div className="max-w-4xl mx-auto text-center mb-20">
          <motion.h2 initial={{ opacity: 0, y: 20 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true }} transition={{ duration: 0.8 }} className="text-5xl md:text-7xl font-bold tracking-tighter text-white mb-6">
            {t.title}
          </motion.h2>
        </div>
        <div className="mb-24">
          <MagicBento data={featureData} enableSpotlight={true} enableBorderGlow={true} spotlightRadius={280} glowColor="14, 165, 233" />
        </div>
        <motion.div initial={{ opacity: 0, y: 30 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true }} transition={{ duration: 1, delay: 0.2 }} className="text-xl md:text-2xl text-gray-400 font-light leading-relaxed max-w-4xl mx-auto space-y-10 text-center">
          {t.paragraphs.map((p, i) => <p key={i}>{p}</p>)}
        </motion.div>
      </div>
    </section>
  );
};

export default About;
